import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { Fragment } from "react";
import { ButtonSecondaryModal } from "../atoms/ButtonSecondaryModal";
import { ButtonPrimaryModal } from "../atoms/ButtonPrimaryModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { ButtonPrimary } from "../atoms/ButtonPrimary";
import { t } from "i18next";

type ModalDescriptionPlanProps = {
  onClickCreate?: () => void;
  Close: () => void;
  open: boolean;
  textButtonCreate?: string;
  textButtonClose?: string;
  children?: React.ReactNode;
  tittleModal: string;
};

export const ModalDescriptionPlan: React.FC<ModalDescriptionPlanProps> = ({
  onClickCreate,
  Close,
  open,
  textButtonCreate,
  textButtonClose,
  children,
  tittleModal,
}) => (
  <Fragment>
    <Dialog open={open} onClose={Close} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-full sm:max-w-xl lg:max-w-5xl sm:max-w-xl  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="">
                <div className="mt-3 sm:ml-0 sm:mt-0">
                  <div className="flex justify-between items-center">
                    <DialogTitle
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      {tittleModal}
                    </DialogTitle>
                    <div className="flex items-center justify-center gap-4">
                      <ButtonPrimary
                        text={t("user.views.download_PDF")}
                        size="large"
                      />
                      <button
                        className="relative text-gray-700 font-bold"
                        onClick={Close}
                      >
                        <FontAwesomeIcon
                          icon={faXmark}
                          className="h-6 w-6 text-gray-700 pt-2"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="mt-2">{children}</div>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </Fragment>
);
